import axios from '@/axios'
import * as types from '../mutation-types'

export default {
	namespaced: true,

	state: {
		defaultWarhorseId: null
	},

	actions: {
		fetchDefaultWarhorse({ commit }) {
			return axios.get('/warehouse').then(data => {
				commit(types.STORE_DEFAULT_WAREHOUSE, data[0] && data[0].id);
				return data[0] && data[0].id;
			})
		}
	},

	mutations: {
		[types.STORE_DEFAULT_WAREHOUSE](state, defaultWarhorseId) {
			state.defaultWarhorseId = defaultWarhorseId;
		}
	},
}